import React from 'react';

type Props = {
    tabs: { title: string; key: string }[];
    activeTab: string;
    setActiveTab: (tab: string) => void;
    inactiveClass?: string;
};

const TabsComponent: React.FC<Props> = ({
    tabs,
    activeTab,
    setActiveTab,
    inactiveClass = 'bg-[#E4F1FF] text-[#8AA8D8] cursor-pointer',
}) => {
    return (
        <div className="flex items-center md:flex-nowrap flex-wrap w-full">
            {tabs.map((t) => (
                <div
                    key={`${t.key}_${t.title}`}
                    className={`text-sm md:text-base font-[WorkSans-Semibold] px-4 py-2 text-center w-full ${
                        activeTab === t.key ? 'bg-[#142C53] text-white cursor-default' : inactiveClass
                    }`}
                    onClick={() => setActiveTab(t.key)}
                >
                    <p className="text-sm text_nowrap">{t.title}</p>
                </div>
            ))}
        </div>
    );
};

export default TabsComponent;
